import { Injectable } from '@angular/core';
import { Game } from '../data/entities';import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor() { }

  // games: Game[] = [];
}
